"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
let VersionTip = class extends Vue {
  constructor() {
    super(...arguments);
    this.notify = null;
    this.btnLoading = false;
    this.submit = _.debounce(() => __async(this, null, function* () {
      yield this.startInstall();
    }), 800);
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  beforeDestroy() {
    return __async(this, null, function* () {
    });
  }
  startInstall() {
    return __async(this, null, function* () {
      if (this.notify) {
        return;
      }
      this.btnLoading = true;
      try {
        yield API.post(`api://base.local/websockets/root`, {
          model: "check.update",
          value: {
            message: "check.update"
          }
        });
      } catch (error) {
        if (this.notify) {
          this.notify.close();
        }
        this.notify = null;
        this.btnLoading = false;
        this.$message.error(this.$t("versiontip.update_failed_please_try_again"));
      } finally {
        this.btnLoading = false;
      }
    });
  }
  toClose() {
    console.log("kjvs://close");
  }
};
VersionTip = __decorateClass([
  Component
], VersionTip);
export {
  VersionTip as default
};
